import { Fragment, useEffect, useState } from 'react';
import './CampaignSEOSprintScreen.css';
import { useParams } from 'react-router-dom';
import {
	CreateSeoSprintImagesTestCSV,
	GetCampaign,
	GetCampaignDefaultSettings,
	GetSeoSprintCSVFiles,
	UploadCampaignFiles
} from '../../../Services';
import PageHeadline from '../../../components/pageHeadline/PageHeadline';
import Spinner from '../../../components/spinner/Spinner';
import { convertImageDataToFile, convertUrlToFile, convertUrlToImageData } from '../../../utils/Common';
import AIModelSelector from '../../../components/aiModelSelector/AIModelSelector';
import { toast } from 'react-toastify';
import { useStateValue } from '../../../StateProvider';
import AIImageQulaitySelector from '../../../components/aiImageQulaitySelector/AIImageQulaitySelector';

const CampaignSEOSprintImagesTest = () => {
	const { campaignId } = useParams();
	const [ { host }, dispatch ] = useStateValue();
	const [ isLoading, setIsLoading ] = useState(false);
	const [ isSubmitting, setIsSubmitting ] = useState(false);
	const [ campaign, setCampaign ] = useState();
	const [ csvFiles, setCsvFiles ] = useState();
	const [ aiModel, setAiModel ] = useState('gpt-image-1');
	const [ seedImagesCommand, setSeedImagesCommand ] = useState();
	const [ numberOfImages, setNumberOfImages ] = useState();
	const [ aiResponse, setAiResponse ] = useState();
	const [ seedImages, setSeedImages ] = useState([]);
	const [ imageQuality, setImageQuality ] = useState('medium');
	const [ aiImageMethodType, setAIImageMethodType ] = useState();

	useEffect(
		() => {
			if (campaignId) {
				getDefaultSettings();
				getCampaign();
				getCSVFiles();
			}
		},
		[ campaignId ]
	);

	useEffect(
		() => {
			if (isSubmitting && aiImageMethodType) {
				let pastedImages = document.querySelectorAll('.pasted-images img');

				if (pastedImages && seedImages && pastedImages.length === seedImages.length) {
					generateCsvFile(aiImageMethodType);
				}
			}
		},
		[ isSubmitting, seedImages, aiImageMethodType ]
	);

	const getCampaign = async () => {
		const response = await GetCampaign(campaignId);

		if (response) {
			document.title = 'SEO Sprint - ' + response.name;

			setCampaign(response);
		}
	};

	const getDefaultSettings = async () => {
		let response = await GetCampaignDefaultSettings();

		if (response && response.data) {
			//setAiModel(response.data.seoSprintAIModel);
			setSeedImagesCommand(response.data.seoSprintSeedImagesCommand);
		}
	};

	const getCSVFiles = async () => {
		const response = await GetSeoSprintCSVFiles(campaignId);

		if (response.success) {
			setCsvFiles(response.data);
		}
	};

	const handleSubmit = async (imageMethodType) => {
		setAIImageMethodType(imageMethodType);
		let pastedImages = document.querySelectorAll('.pasted-images img');

		if (imageMethodType !== 'new' && (!pastedImages || pastedImages.length === 0)) {
			toast.error('At least one seed image is required.');
			return;
		}

		if (!seedImagesCommand || seedImagesCommand === '') {
			toast.error('Command is required.');
			return;
		}

		if (!aiModel || aiModel === '') {
			toast.error('Model is required.');
			return;
		}

		if (!numberOfImages || numberOfImages === '') {
			toast.error('Number of images is required.');
			return;
		}

		setIsSubmitting(true);

		//first upload images
		await uploadImages();
	};

	const uploadImages = async () => {
		let pastedImages = document.querySelectorAll('.pasted-images img');

		pastedImages.forEach(async (image) => {
			if (image.src) {
				let imageName = `seed_${Math.floor(Math.random() * 10000)}`;
				let imageData;

				var data = new FormData();

				if (image.src.indexOf('https://') > -1) {
					// imageData = await convertUrlToImageData(image.src);
					imageData = await convertUrlToFile(image.src, imageName);
				} else if (image.src.indexOf('data:') > -1) {
					imageData = await convertImageDataToFile(image.src, imageName);
					// imageData = image.src;
				}

				if (imageData) {
					//setSeedImages([ ...seedImages, imageData ]);

					data.append('Files', imageData);
					data.append('Target', `SEOSprintTest|${imageName}`);

					const response = await UploadCampaignFiles(campaignId, data);

					if (response !== undefined && response.data && response.data.length > 0) {
						response.data.forEach((file) => {
							setSeedImages([ ...seedImages, file.fullCdnUrl ]);
						});
					}
				}
			}
		});
	};

	const generateCsvFile = async (imageMethodType) => {
		document.querySelector('.pasted-images').innerHTML = '';

		let data = {
			campaignId        : campaignId,
			aiModel           : aiModel,
			seedImagesCommand : seedImagesCommand,
			numberOfImages    : numberOfImages,
			seedImages        : seedImages,
			quality           : imageQuality,
			apiMethodType     : imageMethodType
		};

		//create csv files
		const responseCSV = await CreateSeoSprintImagesTestCSV(campaignId, data);
		if (responseCSV.success) {
			await getCSVFiles();

			if (responseCSV.data && responseCSV.data.data) {
				let responseObj = JSON.parse(responseCSV.data.data);
				if (responseObj) {
					let tempAIResponse = '';
					responseObj.forEach((imageObj) => {
						let imgUrlShort = imageObj.Url;
						if (imgUrlShort.length > 70) {
							imgUrlShort =
								imgUrlShort.substring(0, 35) +
								'...' +
								imgUrlShort.substring(imgUrlShort.length - 35, imgUrlShort.length);
						}
						tempAIResponse +=
							'<div class="mb-2"><a class="btn btn-link p-0" href="' +
							imageObj.Url +
							'" target="_blank">' +
							imgUrlShort +
							'</a></div>';
					});

					setAiResponse(tempAIResponse);
				}
			} else {
				setAiResponse(JSON.stringify(responseCSV));
			}

			setSeedImages([]);
		}

		setIsSubmitting(false);
	};

	return (
		<Fragment>
			<div className="container-fluid campaign-main-container">
				<PageHeadline campaign={campaign} headline={`Campaign - ${campaign ? campaign.name : ''}`} />

				{isLoading ? (
					<Spinner />
				) : (
					<Fragment>
						<div className="seo-sprint-test-container align-items-start">
							<div className="row mb-3">
								<div className="col-6">
									<div className="row mb-3">
										<div className="col-12">
											<h6 className="my-1">Paste Images Here:</h6>
											<div className="pasted-images form-control" contentEditable={true}>
												{/* {imgData.map((image, index) => <img key={index} />)} */}
											</div>
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-3">
											<label htmlFor="seoSprintAIModel" className="form-label">
												ChatGPT Model:
											</label>
											<AIModelSelector
												selectName="seoSprintAIModel"
												isImageModel={true}
												value={aiModel || ''}
												onSelect={(e) => setAiModel(e.target.value)}
											/>
										</div>
										<div className="col-3">
											<label htmlFor="seoSprintAIQuality" className="form-label">
												Quality:
											</label>
											<AIImageQulaitySelector
												selectName="seoSprintAIQuality"
												value={imageQuality || ''}
												onSelect={(e) => setImageQuality(e.target.value)}
											/>
										</div>
										<div className="col-3 ms-3">
											<label htmlFor="numberOfImages" className="form-label">
												Number Of Images:
											</label>
											<input
												type="number"
												className="form-control"
												name="numberOfImages"
												value={numberOfImages || ''}
												onChange={(e) => setNumberOfImages(e.target.value)}
												min={1}
												max={20}
											/>
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-12">
											<label htmlFor="seoSprintSeedImagesCommand" className="form-label">
												Seed Images Command:
											</label>
											<textarea
												className="form-control"
												name="seoSprintSeedImagesCommand"
												value={seedImagesCommand || ''}
												onChange={(e) => setSeedImagesCommand(e.target.value)}
												rows={4}
											/>
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-12">
											<button
												className="btn btn-primary"
												type="button"
												onClick={() => handleSubmit('new')}
											>
												{isSubmitting ? (
													<Fragment>
														<span className="spinner-border m-0 me-2" />
														<span>Generating...</span>
													</Fragment>
												) : (
													<span>Generate CSV File</span>
												)}
											</button>
											{/* <button
												className="btn btn-primary ms-3"
												type="button"
												onClick={() => handleSubmit('edit')}
											>
												{isSubmitting ? (
													<Fragment>
														<span className="spinner-border m-0 me-2" />
														<span>Generating...</span>
													</Fragment>
												) : (
													<span>Generate CSV File (Edit)</span>
												)}
											</button>
											<button
												className="btn btn-primary ms-3"
												type="button"
												onClick={() => handleSubmit('variations')}
											>
												{isSubmitting ? (
													<Fragment>
														<span className="spinner-border m-0 me-2" />
														<span>Generating...</span>
													</Fragment>
												) : (
													<span>Generate CSV File (Variations)</span>
												)}
											</button> */}
										</div>
									</div>

									{csvFiles &&
									csvFiles.length > 0 &&
									!isSubmitting && (
										<Fragment>
											<div className="row">
												{csvFiles
													.filter((x) => x.includes('images_test'))
													.map((csvFilename, index) => {
														let apiUrl =
															host.indexOf('localhost') > -1 ||
															host.indexOf('dev.') > -1 ||
															host.indexOf('dev-') > -1
																? 'dev-api.gbpboost.com'
																: 'gbpapi.gbpboost.com';
														return (
															<div className="col-auto me-3" key={index}>
																<a
																	className="btn btn-link p-0"
																	href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
																	disabled={isSubmitting}
																>
																	{csvFilename}
																</a>
															</div>
														);
													})}
											</div>
										</Fragment>
									)}
								</div>

								<div className="col-6">
									<div className="row mb-3">
										<div className="col-12">
											<label htmlFor="aiResponse" className="form-label">
												Response:
											</label>
											{/* <textarea
												className="form-control"
												name="aiResponse"
												value={aiResponse || ''}
												onChange={(e) => setAiResponse(e.target.value)}
												rows={14}
											/> */}
											<div
												className="form-control"
												dangerouslySetInnerHTML={{ __html: aiResponse || '' }}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Fragment>
				)}
			</div>
		</Fragment>
	);
};

export default CampaignSEOSprintImagesTest;
